/**
 * XinYuanProvider
 * zxw 
 * 创建时间：2025-12-02 
 * 自定义 Provider 用于为 useXChat 提供统一的请求管理和数据格式转换。
 */


import {
    AbstractChatProvider,
} from '@ant-design/x-sdk';


class XinYuanProvider extends AbstractChatProvider {
    constructor(options) {
        super(options);
        this._isTimeout = false;
        this._isStreamTimeout = false;
        this._isRequesting = false;
        this._content = '';
    }

    /**
     * 用于转换onRequest传入的参数，你可以和Provider实例化时request配置中的params进行合并或者额外处理。
     * @param {*} requestParams 
     * @param {*} options 
     * @returns 
     */
    transformParams(requestParams, options) {
        // 清空内容
        this._content = '';
        var _a;
        if (typeof requestParams !== 'object') {
            throw new Error('requestParams must be an object');
        }
        if (requestParams.userAction === 'retry') {
            const messages = this.getMessages();
            const queryMessage =
                (_a = messages || []) === null || _a === void 0
                    ? void 0
                    : _a.reverse().find(({ role }) => {
                        return role === 'user';
                    });
            return Object.assign(
                Object.assign(
                    { message: queryMessage },
                    (options === null || options === void 0 ? void 0 : options.params) || {},
                ),
                requestParams || {},
            );
        }
        return Object.assign(
            Object.assign({}, (options === null || options === void 0 ? void 0 : options.params) || {}),
            requestParams || {},
        );
    }

    /**
     * 将onRequest传入的参数转换为本地（用户发送）的ChatMessage，用于用户发送消息渲染，同时会更新到messages，用于消息列表渲染。
     * 返回的内容将直接作为message的值添加到messages中
     * @param {*} requestParams 
     * @returns 
     */
    transformLocalMessage(requestParams) {
        return requestParams.messages[requestParams.messages.length - 1];
    }

    /**
     * 可在更新返回数据时将数据做转换为ChatMessage数据类型，同时会更新到messages，用于消息列表渲染。
     * @param {*} info 
     * @returns 
     */
    transformMessage(info) {
        const { chunk } = info || {};
        if (!chunk) {
            return {
                content: this._content,
                role: 'assistant',
            };
        }
        const content = chunk.data === '[DONE]' ? '' : JSON.parse(chunk.data).result;
        this._content += content;
        return {
            content: this._content,
            role: 'assistant',
        };
    }
}

export default XinYuanProvider;